import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { GeoEntity } from '@/utils/geo-search'
import isEqual from "lodash/isEqual"

export type CriteriaStore = {
  typeProjet?: "Achat" | "Location",
  localities: GeoEntity[],
  geoRestored: boolean,
  tb?: string[],
  pmax?: string | number,
  pmin?: string | number,
  surfaceHabitableMin?: string | number,
  surfaceHabitableMax?: string | number,
  surfaceTerrainMin?: string | number,
  surfaceTerrainMax?: string | number,
  nbPieces?: string | number,
  nbChambres?: string | number,
  nbTerrasse?: string | number,
  nbPiscine?: string | number,
  nbParking?: string | number,
  nbPiecesDEau?: string | number,
  nbWc?: string | number,
  dpeEtiquetteConso?: string,
  chauffageEnergie?: string,
  chauffageMecanisme?: string,
  aroundValue?: string,
  radiusValue?: number | 'all',
  /** contours [lat, lng] de filtrage Algolia (arrondissements uniquement, cf. getSearchPolygons) */
  polygons?: number[][][],
  displayType: 'list'| 'grid',
  displayMap?: boolean,
  mobileDisplayMap?: boolean,
  ag?: string[],
  setData: (data: Partial<CriteriaStore>) => void
}

export const useSearchCriteriaStore = create<CriteriaStore>()(
  persist(
    (set) => ({
      typeProjet: undefined,
      localities: [],
      geoRestored: false,
      displayType: 'list',
      displayMap: false,
      mobileDisplayMap: false,
      setData: (data) => set((state) => {
        const newState = ({ ...state, ...data})
        return isEqual(state, newState) ? state : newState
      })
    }),
    {
      name: 'search-criteria', // name of the item in the storage (must be unique)
      skipHydration: true
    },
  )
)